export default ($) => {
  const firstModule = $('section.module').first();

  if (firstModule.css("padding-top") === "0px") {
    firstModule.css("padding-top", "40px");
  }
}